export enum TextSectionType {
  BLOCK_QUOTE = 'BLOCK_QUOTE',
  H1 = 'H1',
  HEADING = 'HEADING',
  PARAGRAPH = 'PARAGRAPH',
}
